<template>
  <v-container fluid class="mt-4">
    <v-card flat class="mx-auto">
      <v-card-title class="d-flex justify-space-between">
        <v-btn text color="error" @click="$router.back()">
          <v-icon color="mx-2"> arrow_back </v-icon>
          back
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="text-lg-h6 my-4">
          {{ $route.query.edit !== undefined ? "Edit" : "Add" }} Contact Details
        </div>
        <v-form ref="contactForm" v-model="isValid">
          <v-row>
            <v-col cols="12" md="4" sm="12" xs="12">
              <v-text-field
                v-model="formData.phoneNo"
                class="my-3"
                placeholder="Enter Phone Number"
                label="Phone Number"
                prepend-inner-icon="phone"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="rules.phoneNo"
              />
              <v-select
                v-model="country"
                class="my-3"
                placeholder="Enter Country"
                label="Country"
                prepend-inner-icon="flag"
                :items="countries"
                item-text="name"
                item-value="code"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="formData.address2"
                class="my-3"
                placeholder="Alternate Address"
                label="Alternate Address"
                prepend-inner-icon="contact_mail"
                outlined
                clearable
                persistent-placeholder
                dense
              />
              <v-text-field
                v-if="$route.params.type === 'Work'"
                v-model="formData.location"
                class="my-3"
                placeholder="Enter Location"
                label="location"
                prepend-inner-icon="fmd_good"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-if="$route.params.type === 'Emergency'"
                label="Place of Work"
                v-model="formData.placeOfWork"
                outlined
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12">
              <v-text-field
                v-model="formData.phoneNo2"
                class="my-3"
                placeholder="Enter Emergency Contact"
                label="Emergency Contact"
                prepend-inner-icon="phone_in_talk"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="rules.phoneNo2"
              />
              <v-select
                v-model="formData.city"
                class="my-3"
                placeholder="Enter City"
                label="City"
                prepend-inner-icon="location_city"
                outlined
                clearable
                :items="cities"
                item-text="city"
                item-value="postCode"
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-if="$route.params.type === 'Work'"
                v-model="formData.designation"
                class="my-3"
                placeholder="Enter Designation"
                label="Designation"
                prepend-inner-icon="explore"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-if="$route.params.type === 'Emergency'"
                label="Location"
                v-model="formData.location"
                outlined
                persistent-placeholder
                dense
              />
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12">
              <v-text-field
                v-model="formData.eMail"
                class="my-3"
                placeholder="Enter Email"
                label="Email"
                prepend-inner-icon="email"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="rules.eMail"
              />
              <v-text-field
                v-model="formData.address"
                class="my-3"
                placeholder="Enter Address"
                label="Address"
                prepend-inner-icon="mdi-home"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-if="$route.params.type === 'Work'"
                v-model="formData.placeOfWork"
                class="my-3"
                placeholder="Enter Place Of Work"
                label="Place Of Work"
                prepend-inner-icon="person_pin"
                outlined
                clearable
                persistent-placeholder
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-if="$route.params.type === 'Emergency'"
                label="Designation"
                v-model="formData.designation"
                outlined
                persistent-placeholder
                dense
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          class="white--text mb-3 mr-3"
          @click="submitForm"
        >
          <v-icon class="mr-1 pl-2">
            {{ $route.query.edit !== undefined ? "edit" : "save" }}
          </v-icon>
          <span class="pr-2">
            {{ $route.query.edit !== undefined ? "save" : "submit" }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import AuthService from "../../../dashboard/modules/auth/AuthService";
export default {
  name: "ContactForm",
  data: function () {
    return {
      formData: {
        phoneNo: "",
        eMail: "",
        address: "",
        address2: "",
        phoneNo2: "",
        city: "",
        type: "Personal",
        countryCode: "",
        location: "",
        designation: "",
        placeOfWork: "",
      },
      selectCities: [],
      isValid: false,
      rules: {
        required: (value) => !!value || "Required.",
        eMail: [
          (v) => !!v || "E-mail is required",
          (v) =>
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v,
            ) || "E-mail must be valid",
        ],
        phoneNo: [
          (v) => !!v || "Phone number is required",
          (v) =>
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
            "Invalid phone number format",
        ],
        phoneNo2: [
          (v) =>
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
            "Invalid phone Number",
        ],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.type !== undefined && to.params.type === "Work") {
        v.formData.type = "Work";
      }
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getContact", {
          versionNo: parseInt(to.query.edit),
        });
      }
    });
  },
  mounted() {
    Event.$on("bactToList", () => {
      this.$router.replace({ name: "Contact" });
    });
  },
  computed: {
    country: {
      get() {
        return this.formData.countryCode;
      },
      set(value) {
        this.selectCities = this.cities.filter(
          (item) => item.countryCode === value,
        );
        this.formData.countryCode = value;
      },
    },
    contact() {
      return this.$store.getters["Profile/contactGetters"]("contact");
    },
    cities() {
      return this.$store.getters["Profile/setupGetter"]("cities");
    },
    countries() {
      return this.$store.getters["Profile/setupGetter"]("countries");
    },
  },
  watch: {
    contact() {
      delete this.contact.studentprofiles;
      this.formData = { ...this.contact };
    },
  },
  methods: {
    submitForm() {
      if (!this.isValid) {
        this.$refs.contactForm.validate();
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        delete this.formData.status;
        delete this.formData.versionNo;
        this.$route.query.edit !== undefined
          ? this.$store.dispatch("Profile/editContact", { ...this.formData })
          : this.$store.dispatch("Profile/submitContact", { ...this.formData });
      }
    },
  },
};
</script>
